export const CHART_COLORS = {
  primary: 'var(--color-teal-400)',
  axis: 'var(--color-gray-400)',
  grid: 'var(--color-gray-200)',
  hover: 'var(--color-gray-400)',
  text: 'var(--color-gray-500)',
  white: 'var(--color-white)',
} as const;

export const CHART_CONFIG = {
  yAxisWidth: 40,
  tickMargin: 6,
  margin: { top: 20, right: 50, left: 40, bottom: 20 },
  strokeWidth: { axis: 2, line: 3, hover: 1, activeDot: 2 },
  dotRadius: { normal: 6, active: 8 },
  gridDashArray: '2 3',
  hoverDashArray: '3 3',
  fontSize: { axis: 14, tooltipTitle: 14, tooltipScore: 16 },
} as const;
